module.exports = __webpack_public_path__ + "img/txtmsg.647bd8d0.svg";